export { FeatureDecor } from './FeatureDecor.brand.generated';
